import { render } from "./Replicate.vue?vue&type=template&id=16463561"
import script from "./Replicate.vue?vue&type=script&lang=js"
export * from "./Replicate.vue?vue&type=script&lang=js"

import exportComponent from "/home/www/harixx_test/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Replicate.vue"]])

export default __exports__